import React, { useRef } from 'react';
import {
  useEventPlateId,
  usePlateEditorState,
  getPluginOptions,
  ELEMENT_IMAGE,
} from '@udecode/plate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { onInputChange } from '../../plugins/media/upload/handlers';
import { ToolbarButton } from './ToolbarButton';

export const ImageButton = ({ id }) => {
  const editor = usePlateEditorState(useEventPlateId(id));
  const inputRef = useRef();
  const { allowedImageTypes } = getPluginOptions(editor, ELEMENT_IMAGE);

  return (
    <>
      <label
        htmlFor="file-upload"
        className="plate-toolbar__label file-upload__label"
      >
        <ToolbarButton
          name="Insert image"
          className="button--unstyled plate-toolbar__button"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (inputRef.current) {
              inputRef.current.click();
            }
          }}
          onMouseDown={(e) => e.preventDefault()}
        >
          <FontAwesomeIcon icon={['fa', 'image']} />
        </ToolbarButton>
      </label>
      <input
        ref={inputRef}
        id="file-upload"
        className="plate-toolbar__file-input"
        type="file"
        accept={allowedImageTypes}
        onChange={(e) => {
          onInputChange(editor, e);
          // Need to reset input value so duplicate files can be uploaded.
          if (inputRef.current.value) inputRef.current.value = '';
        }}
      />
    </>
  );
};
